import { useEffect, useRef } from 'react';

/**
 * Эффект для события только на 1 рендер
 * Нужен для запуска обработчиков с меняющейся ссылкой
 * @param handler
 */
export const useFirstEffect = (handler: () => void) => {
    const isFirstEffectCalled = useRef(false);

    useEffect(() => {
        if (!isFirstEffectCalled.current) {
            handler();
            isFirstEffectCalled.current = true;
        }
    }, [handler]);
};
